import { Component, OnInit, ViewContainerRef } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { MatDialog, MatDialogConfig, MatDialogRef } from "@angular/material/dialog";
import { ITask } from '../task.interface';
import * as _ from 'lodash';
import { TaskHttpService } from "../task-http.service";
import { TaskModalComponent } from "../task-modal/task-modal.component";
import moment from 'moment-timezone'
import { IWorker } from "../../../workers-page/workers/workers.interface";
import { IClient } from "../../../clients-page/clients/clients.interface";
import { AuthService } from "../../../../shared/services/auth.service";
import { UtilsService } from "../../../../shared/services/utils.service";
import { ClientsModalComponent } from "../../../clients-page/clients/clients-modal/clients-modal.component";
import { WorkersModalComponent } from "../../../workers-page/workers/workers-modal/workers-modal.component";

let self: any;

@Component({
  selector: 'app-task-movements',
  templateUrl: './task-movements.component.html',
  styleUrls: ['./task-movements.component.css']
})
export class TaskMovementsComponent implements OnInit {
  dialog: MatDialogRef<any>;
  loading = false;
  submitted = false;
  task!: ITask;
  worker!: IWorker;
  client!: IClient;
  form!: UntypedFormGroup;
  movements: any;
  isByTask: boolean = false;
  isByWorker: boolean = false;
  isByClient: boolean = false;
  monthOffset: number = 0;
  searchClient: string = '';
  searchTask: string = '';
  searchCategory: string = '';
  searchWorker: string = '';
  offset = new Date();
  constructor(
    public dialogRef: MatDialogRef<any>,
    private fb: UntypedFormBuilder,
    public _TaskHttpService: TaskHttpService,
    private _AuthService: AuthService,
    private _UtilsService: UtilsService,
    private _viewContainerRef: ViewContainerRef,
    private _dialog: MatDialog,
  ) {
    self = this;
    this.dialog = dialogRef;
  }

  ngOnInit() {
    this.getMovements()
  }

  periodChange() {
    this.getMovements();
  }

  lazySearchTmp: number = 0;
  lazySearch() {
    let tmp = new Date().getTime();
    this.lazySearchTmp = tmp;
    setTimeout(() => {
      if (tmp == this.lazySearchTmp) {
        this.getMovements();
      }
    }, 1000);
  }

  getFilter() {
    let filter: any = { filters: {} };

    const date = new Date();

    if (this.monthOffset == 0) {
      filter.filters.dateStart = new Date(date.getFullYear(), date.getMonth(), 1).toISOString().substring(0, 10) + 'T00:00:00.000Z';
      filter.filters.dateEnd = new Date(date.getFullYear(), date.getMonth(), date.getDate()).toISOString().substring(0, 10) + 'T23:59:59.999Z';
    } else if (this.monthOffset == 1) {
      //filter.filters.dateStart = new Date(date.getFullYear(), date.getMonth() - 1, 1).toISOString();
      //filter.filters.dateEnd = new Date(date.getFullYear(), date.getMonth(), 0).toISOString().substring(0, 10) + 'T23:59:59.999Z';
      const startOfMonth = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
      const endOfMonth   = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
      filter.filters.dateStart = startOfMonth + 'T00:00:00.000Z';
      filter.filters.dateEnd = endOfMonth + 'T23:59:59.999Z';
    }

    if (this.searchClient.length > 0) {
      filter.filters.client = this.searchClient;
    }

    if (this.searchTask.length > 0) {
      filter.filters.task = this.searchTask;
    }

    if (this.searchCategory.length > 0) {
      filter.filters.category = this.searchCategory;
    }

    if (this.searchWorker.length > 0) {
      filter.filters.worker = this.searchWorker;
    }

    if (this.task) {
      filter.task = this.task._id;
    }

    if (this.worker) {
      filter.worker = this.worker._id;
    }

    if (this.client) {
      filter.client = this.client._id;
    }

    return filter;
  }

  getMovements() {
    this.movements = [];
    let filter = this.getFilter();
    if (this.task) {
      this.isByTask = true;
      filter.filters.offset = moment.tz.guess();
      this._TaskHttpService.getTimeTrackByTask(filter).subscribe((movements: any) => {
        this.movements = movements;
      });
    }
    if (this.worker) {
      this.isByWorker = true;
      filter.filters.offset = moment.tz.guess();
      this._TaskHttpService.getTimeTrackByWorker(filter).subscribe((movements: any) => {
        this.movements = movements;
      });
    }
    if (this.client) {
      this.isByClient = true;
      filter.filters.offset = moment.tz.guess();
      this._TaskHttpService.getTimeTrackByCient(filter).subscribe((movements: any) => {
        this.movements = movements;
      });
    }
  }

  exportListByWorker() {
    let filter = this.getFilter();
    filter.filters.offset = moment.tz.guess();
    this._TaskHttpService.exportTimeTrackByWorker(filter);
  }

  exportListByClient() {
    let filter = this.getFilter();
    filter.filters.offset = moment.tz.guess();
    this._TaskHttpService.exportTimeTrackByClient(filter);
  }

  exportListByTask() {
    let filter = this.getFilter();
    filter.filters.offset = moment.tz.guess();
    this._TaskHttpService.exportTimeTrackByTask(filter);
  }

  public convertMsToHM(ms: number): string {
    return this._UtilsService.convertMsToHM(ms);
  }

  /*getFormathours(input) {
    var totalHours, totalMinutes, totalSeconds, hours, minutes, seconds, result = '';
    totalSeconds = input / 1000;
    totalMinutes = totalSeconds / 60;
    totalHours = totalMinutes / 60;

    seconds = Math.floor(totalSeconds) % 60;
    minutes = Math.floor(totalMinutes) % 60;
    hours = Math.floor(totalHours) % 60;

    // console.log(hours + ' : ' + minutes + ' : ' + seconds);
    if (hours !== 0) {
      if (hours.toString().length == 1) hours = '0' + hours;
      result += hours + ':';
    } else result += '00:';

    if (minutes !== 0) {
      if (minutes.toString().length == 1) minutes = '0' + minutes;
      result += minutes + ':';
    } else result += '00:';

    if (seconds !== 0) {
      if (seconds.toString().length == 1) seconds = '0' + seconds;
      result += seconds;
    } else result += '00';

    return result.split('NaN').join('00');
  }*/

  getFormathours(ms: any) {
    var d, h, m, s, result = '';
    s = Math.floor(ms / 1000);
    m = Math.floor(s / 60);
    s = s % 60;
    h = Math.floor(m / 60);
    m = m % 60;
    d = Math.floor(h / 24);
    h = h % 24;
    h += d * 24;

    if (h !== 0) {
      if (h.toString().length == 1) h = '0' + h;
      result += h + ':';
    } else result += '00:';

    if (m !== 0) {
      if (m.toString().length == 1) m = '0' + m;
      result += m + ':';
    } else result += '00:';

    if (s !== 0) {
      if (s.toString().length == 1) s = '0' + s;
      result += s;
    } else result += '00';

    return result.split('NaN').join('00');

  }

  openClientModal(client: IClient) {
    let config = new MatDialogConfig();
    // config.disableClose = true;
    config.width = '700px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.dialogRef = this._dialog.open(ClientsModalComponent, config);
    self.dialogRef.componentInstance.client = client;
    self.dialogRef.componentInstance.readOnly = true;
    self.dialogRef.componentInstance.showEdit = false;

    self.dialogRef.afterClosed().subscribe((result: any) => {
      self.dialogRef = null;
    });
  }

  openWorkerModal(worker: IWorker) {
    let config = new MatDialogConfig();
    // config.disableClose = true;
    config.width = '700px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.dialogRef = this._dialog.open(WorkersModalComponent, config);
    self.dialogRef.componentInstance.worker = worker;
    self.dialogRef.componentInstance.readOnly = true;
    self.dialogRef.componentInstance.showEdit = false;

    self.dialogRef.afterClosed().subscribe((result: any) => {
      self.dialogRef = null;
    });
  }

  openTaskModal(task: ITask) {
    let config = new MatDialogConfig();
    config.width = '1300px';
    config.maxWidth = '90vw';
    config.hasBackdrop = true;
    config.disableClose = true;
    config.viewContainerRef = this._viewContainerRef;
    self.dialogRef = this._dialog.open(TaskModalComponent, config);
    self.dialogRef.componentInstance.task = task;
    self.dialogRef.componentInstance.readOnly = true;
    self.dialogRef.componentInstance.showEdit = true;

    self.dialogRef.afterClosed().subscribe((result: any) => {
      self.dialogRef = null;
    });
  }
}